import { ElementRef, OnInit } from '@angular/core';
import { LabelsPipe } from '@fuse/pipes/labels/labels.pipe';
var PalantirTagComponent = /** @class */ (function () {
    function PalantirTagComponent(labels, host) {
        this.labels = labels;
        this.host = host;
        this.size = 'base';
        this.style = 'soft';
        this.shape = 'rounded';
        this.activatable = false;
        this.minified = false;
        this.badge = false;
    }
    PalantirTagComponent.prototype.ngOnInit = function () {
        this.host.nativeElement.style.setProperty('--palantir-tag-color', this.labels.transform(this.color).color);
    };
    return PalantirTagComponent;
}());
export { PalantirTagComponent };
